<template>
    <section id="container">
        <section id="user-visual" class="mypage">
            <div class="grid--con">
                <div class="user-visual-txt">신청ㆍ설치안내<!--<span> 궁금한 점이 있으신가요? 고객센터에서 해결 방법을 찾아보세요.</span>--></div>
            </div>
        </section>
        <div id="content" class="sub">
            <div class="grid--con-sub">
                <img src="../../../../assets/i5gam/images/img-i5gam-installnfo.png" />
                <h1 class="tit-type3 mgt60">아이오감 신청, 계약서 작성하기</h1>
                <ul class="txt-type3-1">
                	<li>1) 보육통합정보시스템에서 <span class="pc03">"(주)에이티엔 (with 온앤온정보시스템)"</span> 업체 선정 하기<br />
                		<div class="txt-type4" style="margin:10px 0px 10px 20px;">보육통합정보시스템에서 업체 선정만으로 계약이 되는 것이 아니니 계약서를 작성해주세요.</div>
                	</li>
                	<li>2) 계약서 작성
                		<ul class="txt-type3-2">
                			<li>아이오감 홈페이지에서 표준계약서를 다운로드 하여 작성하시고, 아이오감 대표메일  <span class="pc03">(i5gam@onandon.co.kr)</span> 로 보내주세요.<br />아이오감에서 계약서 확인 후 확인 전화를 드립니다.</li>
                		</ul>
                	</li>
                </ul>
                <h1 class="tit-type3">리더기 설치</h1>
                <ul class="txt-type3-1">
                	<li>1) 계약 체결 후 아이오감 고객센터에서 전문상담사가 <span class="pc03">권역별 설치 일정 확인전화</span>를 드립니다.</li>
                	<li>2) 아이오감 전문 설치기사가 방문하여 아이오감 리더기를 설치해드립니다.
                		<ul class="txt-type3-2">
                			<li>방문 전 설치기사가 <span class="pc03">방문 예정 전화</span>를 드립니다.</li>
                			<li>아이오감 <span class="pc03">리더기 설치 후</span> 원아용 태그는 신청하신 수량에 맞게 택배로 발송됩니다.</li>
                		</ul>
                	</li>
                </ul>
                <div class="mgt20"><img src="../../../../assets/i5gam/images/img21.png" /></div>
                <h1 class="tit-type3">정산 /세금계산서 발행</h1>
                <ul class="txt-type3-1">
                	<li>1) 설치 완료 후 <span class="pc03">카드 결제나 무통장 입금</span>으로 결제하실 수 있습니다.</li>
                	<li>2) 보조금 정산에 관련된 서류와 세금계산서를 발행해드립니다.
                		<ul class="txt-type3-2">
                			<li>보조금으로 지원되는 비용 외 어린이집 자부담 구입이 있는 경우, 보조금 정산서류와 어린이집 정산서류를 각각 발행해드립니다.</li>
                		</ul>
                	</li>
                </ul>
                <h1 class="tit-type3">유지 /보수</h1>
                <ul class="txt-type3-1">
                	<li>1) 아이오감 이용료는 매월 20일 00시 아동현원기준으로 결제됩니다.</li>
                	<li>2) 이용료 결제를 위한 <span class="pc03">어린이집 카드 등록</span>을 해주세요.<br /><div class="txt-type4" style="margin:10px 0px 10px 20px;">무통장입금도 가능합니다.</div></li>
                	<li>3) 아이오감 사용 중 유지/ 보수에 관한 사항은 고객센터  (☎ 1661-5029)로 연락주세요. </li>
                </ul>
                <h1 class="tit-type3">아이오감 설치 후기</h1>
                 <div><img src="../../../../assets/i5gam/images/img22.png" /></div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'reqInstall'
    }
</script>

<style scoped>

</style>